import React, { Component } from 'react';
import { Form, Button, Label, Message, Icon } from 'semantic-ui-react';
import { updateInPath } from '../../../../common/utils/utils.js';
import { clone } from 'ramda';
import { withNamespaces } from 'react-i18next';

class ConfirmSignUp extends Component {
  constructor(props) {
    super();

    this.state = {
      username: '',
      code: ''
    };
  }

  handleChange = (e, { name, value }) => {
    const val = (name === 'username' ? value.trim().toLowerCase() : value);
    this.setState(prevState => updateInPath(prevState, name, val));
  }

  handleSubmit = () => {
    const data = clone(this.state);
    this.props.onSubmit(data.username, data.code);
  }

  handleResendCode = () => {
    this.props.onResendCode(this.state.username);
  }

  render() {
    const { username, code } = this.state;
    const { t, error } = this.props;

    return (
      <Form>
        <Form.Field>
          <p> {t('public:auth.code_text')}</p>
          <div>
            {t('public:auth.code_forgotten')} &nbsp;
            <Label
              size='tiny'
              onClick={this.handleResendCode}>
               <Icon name='mail' />
              {t('public:auth.code_resend')}
            </Label>
          </div>
        </Form.Field>
        <Form.Group>
          <Form.Input
            width={10}
            required
            label={t('public:auth.email')}
            placeholder={t('public:auth.email_i')}
            name='username'
            value={username}
            onChange={this.handleChange}
          />
          <Form.Input
            width={6}
            required
            label={t('public:auth.code')}
            placeholder={t('public:auth.code_i')}
            name='code'
            value={code}
            onChange={this.handleChange}
          />
        </Form.Group>
        {
          this.props.error &&
            <Message negative>
              <Message.Header>{t('public:auth.code_failed')}</Message.Header>
              <p>{t(`public:auth.ex.${error}`)}</p>
            </Message>
        }
        <Button
          fluid
          disabled={!username || !code}
          positive
          className='rtxAuthFormButton'
          content={t('public:auth.confirm')}
          onClick={this.handleSubmit}
        />
      </Form>
    );
  }
}

export default withNamespaces('public')(ConfirmSignUp);



// WEBPACK FOOTER //
// ./src/public/components/Auth/Forms/ConfirmSignUp.js